import styled from "styled-components";

// kitchen delivery times
import KitchenDeliveryTimes from "../Orders/KitchenDeliveryTimes";

const InfoPage = () => (
  <Wrapper>
    <KitchenDeliveryTimes />
  </Wrapper>
);

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
`;

export default InfoPage;
